/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnedisAcquisitionStatusesPagedList } from '../../models/enedis-acquisition-statuses-paged-list';
import { SortDirection } from '../../models/sort-direction';

export interface GetEnedisAcquisitionStatuses$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
}

export function getEnedisAcquisitionStatuses(http: HttpClient, rootUrl: string, params?: GetEnedisAcquisitionStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisAcquisitionStatusesPagedList>> {
  const rb = new RequestBuilder(rootUrl, getEnedisAcquisitionStatuses.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortDirection', params.sortDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnedisAcquisitionStatusesPagedList>;
    })
  );
}

getEnedisAcquisitionStatuses.PATH = '/enedis/acquisitionStatus';
